import { render } from "./EditCourse.vue?vue&type=template&id=788494fe&scoped=true"
import script from "./EditCourse.vue?vue&type=script&lang=js"
export * from "./EditCourse.vue?vue&type=script&lang=js"

import "./EditCourse.vue?vue&type=style&index=0&id=788494fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788494fe"]])

export default __exports__